import script from "./HideOverflowDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./HideOverflowDescription.vue?vue&type=script&setup=true&lang=ts"

import "./HideOverflowDescription.vue?vue&type=style&index=0&id=24b962d7&lang=css"

const __exports__ = script;

export default __exports__